module.exports = __webpack_public_path__ + "img/P2.56723e2d.png";